var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('h1',[_vm._v("Error")]),_c('h2',[_vm._v("Sorry something went wrong, please try again.")]),_c('router-link',{staticClass:"button",attrs:{"to":{ name: 'Contact' }}},[_vm._v(" Try again ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }